const e = "styles-module__select___mHY5s", l = {
  select: e,
  "select--error": "styles-module__select--error___C-VcY",
  "select--valid": "styles-module__select--valid___z3kdQ",
  "select--multiple": "styles-module__select--multiple___KYRbJ"
};
export {
  l as default,
  e as select
};
